import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchItemUnitsQuery } from '@/features/itemUnits'
import { fetchItemUnitsList } from '@/features/itemUnits/api'

import { ItemUnitsSearchSchema } from './-models/item-units-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/item-units/'
)({
  validateSearch: (search) => parse(ItemUnitsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchItemUnitsQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      itemUnits: await fetchItemUnitsList(query, abortController.signal)
    }
  }
})
